"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteFetchWithAuthorization = void 0;
var tslib_1 = require("tslib");
var error_handlers_1 = require("../error-handlers");
var response_validator_1 = require("../error-handlers/response-validator");
var access_token_1 = require("../service/access-token");
var request_path_1 = require("../service/request-path");
var auth_suite_fetch_helper_1 = require("./auth-suite-fetch-helper");
var fetch_1 = require("./fetch");
var AuthSuiteFetchWithAuthorization = /** @class */ (function (_super) {
    tslib_1.__extends(AuthSuiteFetchWithAuthorization, _super);
    function AuthSuiteFetchWithAuthorization() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestPathService = request_path_1.requestPathAuthSuiteService;
        _this.fetch = function (authSuiteFetchData) {
            return access_token_1.accessTokenService.getAccessToken().then(function (tokens) {
                var requestConfig = auth_suite_fetch_helper_1.authSuiteFetchHelper.getRequestConfig(authSuiteFetchData, tokens);
                // eslint-disable-next-line no-warning-comments
                // TODO - give it more accurate name: 'getPath' resolves not only a path but query params also
                // https://jira.mtvi.com/browse/UPSERVICES-6950
                return _this.getPath(authSuiteFetchData)
                    .then(function (getPathResult) { return fetch(getPathResult.path, requestConfig); })
                    .then(function (response) { return response_validator_1.responseValidator.validateResponse(response); })
                    .then(function (response) {
                    if (authSuiteFetchData.responseGuard) {
                        return authSuiteFetchData.responseGuard(response);
                    }
                    return response;
                })
                    .catch(function (errorResponse) {
                    return error_handlers_1.requestErrorHandler.handleErrorResponse(authSuiteFetchData, errorResponse, _this.fetch);
                });
            });
        };
        return _this;
    }
    return AuthSuiteFetchWithAuthorization;
}(fetch_1.Fetch));
exports.authSuiteFetchWithAuthorization = new AuthSuiteFetchWithAuthorization();
